// Module
var code = `<div class="alert-selector-button">
    <terceraButton enabled="{{.enabledCreateAlert}}"
                   tooltip="{{.createBtnTooltip}}"
                   text="{{.isUpdate ? buttonApplyText : buttonCreateText}}"
                   terceraButtonStyle="js-button-create-alert {{.advancedButtonStyle}}"
                   on-btnClick="btnCreateOrApplyClick" />
                   
    <terceraButton text="{{.buttonCancelText}}"
                   terceraButtonStyle="js-button-gray25"
                   on-componentClick="btnCancelClick" />
</div>`;
// Exports
export default code;